/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GetLocalText} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import { GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {
  product?:any;
  sizes?:any;
  availableSizesText?:any;
}

interface IProps {
  product?: any;
  hideTitle?:boolean;
  parentProduct?:any;
}

/**
 *
 * Sizes component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class Sizes extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      product:null
    };
  }
  public componentDidMount = async () => {
    if(this.props.product.attributes.category != "lDtB8joWup" && this.props.product.attributes.sizes){
      let sizes = this.props.product.attributes.sizes;
      if(this.props.parentProduct){
        sizes = this.props.parentProduct.attributes.sizes;
      }
      //TODO get parent product
      /*
        if(this.props.product.attributes.parentProducts && this.props.product.attributes.parentProducts[0]){
          if(window.productDictionary[this.props.product.attributes.parentProducts[0]]){
            sizes = window.productDictionary[this.props.product.attributes.parentProducts[0]].attributes.sizes;
          }
        }
      */
      let availableSizesText = await GetLocalText('availableSizesText');
      if(sizes != []){
        let sortedSizes = sizes.sort(function(a:any, b:any){return parseFloat(a.split('-')[0]) - parseFloat(b.split('-')[0])});
        this.setState({
          sizes:sortedSizes,
          availableSizesText:availableSizesText
        })
      }
    }
  }

  public render(): JSX.Element {
    if(!this.state.sizes || this.state.sizes.length == 0) return <span/>;
    return (
      <div>
        {!this.props.hideTitle && <h6 className={"product-size-title tiny-top-margin text-color-secondary"} style={{'marginBottom':'0px', marginTop:'10px'}}>{this.state.availableSizesText}</h6>}
        <div className={"product-size-container"}>
          {this.state.sizes.map((data:any,index:any) => {
            return(
              <p key={'prod-sizes-'+index} className={"product-size text-color-primary secondary-background"}>
                {data}
              </p>
            )})}
        </div>
      </div>
    );
  }
}

export default Sizes;
